export const environment: any = {
  production: true,
  apiUrl: 'https://hml.api.admin.merchandising-bb.com.br',
  useToken: true,
};
